import { createRoute } from '@tanstack/react-router'
import RequireAuth from 'src/blocks/RequireAuth'
import { rootRoute } from 'src/router/root-route'

import MainLayout from '../MainLayout/MainLayout'

export const mainLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  component: () => (
    <RequireAuth>
      <MainLayout />
    </RequireAuth>
  ),
  id: 'main-layout'
})
